<template>
  <div>
    <!-- <v-card class="pa-0" v-allowed="'edit_schedule'" elevation="0" outlined>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn outlined elevation="0" small color="primary" @click="updateScheduleNotes('update')">{{
          $t('message.update')
          }}</v-btn>
        <v-btn elevation="0" small @click="updateScheduleNotes()">{{ $t('message.clear')
          }}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-avatar size="20" v-if="scheduleNotes && scheduleNotes.user">
          <ImageDisplay v-if="scheduleNotes.user.userImageSmall" :src="scheduleNotes.user.userImageSmall" />
          <img v-else :src="assets('default-profile-avatar.png')" />
        </v-avatar>
        <span class="ml-1" v-if="scheduleNotes && scheduleNotes.user">{{ $t('message.last_update_by') }}
          {{ scheduleNotes.user.displayName }}</span>
        <span v-if="scheduleNotes && scheduleNotes.user" style="color:gray; margin-left: 10px">{{ $d(new
          Date(scheduleNotes.date), 'short', $i18n.locale) }}</span>
        <v-textarea style="margin-top:10px" rows="3" :auto-grow="true" outlined v-model="scheduleNotes.notes"
          :label="$t('message.schedule_notes')"></v-textarea>
        <div class="supportive-text" style="margin-top:-20px">{{ $t('message.schedule_notes_explained') }}</div>
      </v-card-text>
    </v-card> -->


    <AcademyScheduleList ref="academyScheduleList" />


    <alert-message :text="updateMessage" />
  </div>
</template>

<script>
import AlertMessage from "@/components/displays/AlertMessage.vue";
import AcademyScheduleList from "@/components/plus/calendar/AcademyScheduleList.vue";
import Api from "@/services/Api2";

export default {
  props: {
    activeTab: {
      type: Number,
      default: 0
    }
  },
  components: {
    AlertMessage,
    AcademyScheduleList
  },
  data() {
    return {
      loading: true,
      academy: null,
      scheduleNotes: {},
      updateMessage: null
    }
  },
  mounted() {
    Api()
      .get(
        "admins/academy/" +
        this.$store.state.selectedAcademy +
        "?populate=schedule_notes"
      )
      .then((response) => {
        this.academy = response.data;
        this.scheduleNotes =
          response.data.extraFields && response.data.extraFields.scheduleNotes
            ? response.data.extraFields.scheduleNotes
            : {};
        this.loading = false;
        this.$emit('loaded');
      });
  },
  methods: {
    refreshSchedule() {
      const list = this.$refs.academyScheduleList;
      if (list && typeof list.loadSchedule === 'function') {
        list.loadSchedule();
      }
    },
    updateScheduleNotes(val) {
      let notes = null;
      if (val) notes = this.scheduleNotes.notes;
      else this.scheduleNotes = {};
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/schedule/notes",
          {
            notes: notes,
          }
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.showAlert("success", this.$t("message.updated"));
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", this.$t("message.error_generic"));
        });
    }
  }
}
</script>
